import React from 'react';
import './Footer.css';
import { getAppVersion, getBuildDate } from '../../utils/version';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const appVersion = getAppVersion();
  const buildDate = getBuildDate();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-text">
          <i className="bi bi-hospital me-2"></i>
          © {currentYear} Doctor Portal. All rights reserved.
          <span className="version-info ms-3" title={`Built on ${buildDate}`}>
            <i className="bi bi-info-circle me-1"></i>
            v{appVersion}
          </span>
        </div>
        <div className="footer-links">
          <span>
            <i className="bi bi-shield-check me-1"></i>
            Secure & Confidential
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;